<div
  class="anb-root"
  [class.anb-root--embedded]="embedded"
  [style.background]="theme.panelBg"
  [style.color]="theme.panelText"
>
  <span class="anb-text">
    <strong>{{ text(announcement.title) }}</strong>
    <span *ngIf="feature">{{ text(feature.description) }}</span>
  </span>
  <button
    type="button"
    class="anb-cta"
    *ngIf="showCta"
    [style.background]="theme.accent"
    [style.color]="theme.accentText"
    (click)="onCtaClick()"
  >
    {{ text(feature.ctaLabel) || ("APP_BUTTONS.OK" | translate) }}
  </button>
  <button type="button" class="anb-close" (click)="close()" [attr.aria-label]="'APP_BUTTONS.CLOSE' | translate">
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M18 6 6 18M6 6l12 12"/></svg>
  </button>
</div>
